import React, { ChangeEvent, useEffect, useMemo, useState } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { Grid, TextField } from '@material-ui/core';
import useDeepCompareEffect from 'use-deep-compare-effect';
import styled from 'styled-components';
import { get, isEmpty } from 'lodash';
import SahamAccordion from 'components/SahamAccordion';
import { translate } from 'containers/services/translate';
import messages from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/messages';
import { IJudgementOnMeritsBeneficiaryInfo } from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/typings';
import {
  BENEFICIARY,
  JUDGEMENT_ON_MERITS_VICTIM,
} from 'containers/data-structure';
import PrimaryButton from 'components/Buttons/PrimaryButton';
import BeneficiaryAccordion from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/BeneficairyAccordion';
import { isObjectAttributesEmpty } from 'containers/PreOpeningPage/utils';
import { Listings } from 'containers/AppContainer/typings';
import {
  victimConsistencyCheck,
  checkVictimExistanceCivilParty,
  getDeceasedVictims,
  getJudgementOnMeritsByVictim,
  resolveCalculatedAmount,
  resolveJudiciaryAmount,
  resolveSlectedDeceasedVictims,
  showAddBeneficiaries,
  shouldShowFees,
  getCalculatedAmountByBeneficiary,
  isRejected,
  resetReasonNonCompensationBeneficiary,
  areBeneficiariesDataInvalid,
  resetCompensationBenficiary,
} from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/utils';
import { JudgementOnMeritsType } from 'containers/LawyerLegalProceedingsPage/typings';
import { JudgementOnMeritsVictim } from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/typings';
import { STATUS_REJECTED } from 'containers/LawyerFeeNote/constants';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import BeneficiaryInfo from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/BeneficiaryInfo';
import { FEES } from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/CivilJudgementRecap/data-structure';
import {
  BENEFICIARY_JUDGEMENT,
  EMPTY_BENEFICIARY_JUDGEMENT,
} from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/constants';
import { shouldValidateDesceasedVictim } from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/form-validation';
import { VictimType } from 'typings/globalTypes';

export interface DeceasedVictimProps {
  intl: IntlShape;
  judgementAdd: any;
  isRecap: Boolean;
  listing: Listings;
  RecapInfo?: any;
  handleChangeDesceasedVictim: Function;
  handleChangeBeneficiaries: Function;
  beneficiairies: any;
  isManager: boolean;
  setBeneficiaryContestationReasons?: Function;
  beneficiaryContestationReasons?: any;
  isContested: boolean;
  desceasedVictims: any;
  dahirAmount: any;
  judgementAddAppeal?: any;
  currentJudiciaryProcess: any;
  victims?: VictimType[];
  judgementOnMerits: JudgementOnMeritsType;
  allVictims?: VictimType[];
  associatedVictims?: any;
  jomDeceasedVictims?: any;
  isMultiple?: boolean;
  sharedResponsability: string;
  judgementOnMeritsRequest: any;
  setJudgementOnMeritsRequest: any;
  dahirAmountByVictimKey: any;
  lossDate?: string;
}

const Container = styled.div`
  .subContainer {
    display: flex;
    justify-content: space-between;
    width: 100% !important;
  }
  .container {
    margin-top: 15px;
    width: 100% !important;
  }
  .sub-container {
    margin-bottom: 30px;
    margin-top: 30px;
    padding-left: 10px;
    background: #ffffff;
    box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.12);
    border-radius: 4px;
  }
  .input {
    width: 80%;
    font-size: 20px;
    margin-top: 10px;
  }
  .input-13 {
    width: 100%;
    font-size: 20px;
  }
  .select-field {
    margin-top: 14px;
  }
  .input-1 {
    width: 93%;
    font-size: 20px;
    margin-top: 20px;
  }
  .block {
    margin-bottom: 100px;
  }
  .MuiInput-formControl {
    font-weight: bold;
  }
  .MuiInputLabel-root {
    font-size: 16px;
  }
  .MuiFormControlLabel-label.Mui-disabled {
    color: black;
    font-weight: bold;
  }
  .MuiCheckbox-colorPrimary.Mui-disabled {
    color: black;
  }
`;

const DeceasedVictim: React.FC<DeceasedVictimProps> = (props): JSX.Element => {
  const jomId = get(props.judgementOnMerits, 'judgementOnMerits.jom.id', '');
  const [expanded, setExpanded] = React.useState(true);
  const [openBeneficiaryForm, setOpenBeneficiaryForm] = useState<any>({});

  const [deceasedVictimsToShow, setDeceasedVictimsToShow] = React.useState<any>(
    [],
  );

  const openFormBeneficiary = (indexVictim: number) => {
    setOpenBeneficiaryForm({ [indexVictim]: true });
  };

  const closeFormBeneficiary = (indexVictim: number) => {
    setOpenBeneficiaryForm({ [indexVictim]: false });
  };
  const [judgement, setJudgement] = useState({} as any);

  const defaultDeceasedVictims = useMemo(
    () =>
      getDeceasedVictims(
        props.judgementAdd,
        props.judgementAddAppeal,
        props.currentJudiciaryProcess,
      ).map((el: any) => {
        const jomId = get(
          props.judgementOnMerits,
          'judgementOnMerits.jom.id',
          '',
        );
        return {
          ...el,
          beneficiaries: get(el, 'beneficiaries', []).map(
            (beneficiary: any) => {
              const jomBeneficiary =
                get(beneficiary, 'jomBeneficiaries', []).find(
                  (jomB: any) => jomB.judgementOnMeritsId === jomId,
                ) || {};
              const beneficiaryWithoutCompensation =
                get(beneficiary, 'jomBwc', []).find(
                  (jomB: any) => jomB.judgementOnMeritsId === jomId,
                ) || {};
              return {
                ...beneficiary,
                beneficiaryWithoutCompensation,
                beneficiaryIdJom: get(jomBeneficiary, `id`, ''),
                victimKey: get(el, 'victimKey'),
                moralePrejudice: get(jomBeneficiary, `moralePrejudice`, null),
                judgementAmount: get(jomBeneficiary, `judgementAmount`, null),
                materialPrejudice: get(
                  jomBeneficiary,
                  `materialPrejudice`,
                  null,
                ),
                isDeletedCompensation:
                  !isEmpty(beneficiaryWithoutCompensation) &&
                  !get(beneficiaryWithoutCompensation, 'isDeleted', false),
                ...(featureService.hasFeature(FEATURES.GET_DAHIR_AMOUNT_V2)
                  ? getCalculatedAmountByBeneficiary(
                      props.judgementOnMerits,
                      props.dahirAmountByVictimKey,
                      { ...jomBeneficiary, beneficiary },
                      get(el, 'victimKey'),
                    )
                  : undefined),
              };
            },
          ),
        };
      }),

    // eslint-disable-next-line react-hooks/exhaustive-deps
    [props.judgementAdd, props.judgementOnMerits, props.dahirAmount],
  );

  const handleItemCheckBox = (type: string, id: any) => (
    event: React.ChangeEvent<{ value: string; checked: boolean }>,
  ) => {
    let judgementCheck = { ...judgement };
    if (!judgementCheck[id]) {
      judgementCheck[id] = {
        ...EMPTY_BENEFICIARY_JUDGEMENT,
      };
    }
    const substrings = id.split('-');
    const desceasedVictims = [...deceasedVictimsToShow];
    switch (type) {
      case BENEFICIARY_JUDGEMENT.COMPENSATION:
        resetCompensationBenficiary(desceasedVictims, substrings);
        judgementCheck[id] = {
          ...EMPTY_BENEFICIARY_JUDGEMENT,
          [BENEFICIARY_JUDGEMENT.COMPENSATION]: !get(
            judgementCheck[id],
            [BENEFICIARY_JUDGEMENT.COMPENSATION],
            false,
          ),
        };
        break;
      case BENEFICIARY_JUDGEMENT.FORM_REJECTION:
        resetReasonNonCompensationBeneficiary(desceasedVictims, substrings);
        judgementCheck[id] = {
          ...EMPTY_BENEFICIARY_JUDGEMENT,
          [BENEFICIARY_JUDGEMENT.FORM_REJECTION]: !get(
            judgementCheck[id],
            [BENEFICIARY_JUDGEMENT.FORM_REJECTION],
            false,
          ),
        };
        break;
      case BENEFICIARY_JUDGEMENT.SUBSTANTIVE_REJECTION:
        resetReasonNonCompensationBeneficiary(desceasedVictims, substrings);
        judgementCheck[id] = {
          ...EMPTY_BENEFICIARY_JUDGEMENT,
          [BENEFICIARY_JUDGEMENT.SUBSTANTIVE_REJECTION]: !get(
            judgementCheck[id],
            [BENEFICIARY_JUDGEMENT.SUBSTANTIVE_REJECTION],
            false,
          ),
        };
        break;
    }
    setDeceasedVictimsToShow(desceasedVictims);
    props.handleChangeBeneficiaries(
      desceasedVictims.flatMap(item => get(item, 'beneficiaries', [])),
    );
    setJudgement(judgementCheck);
  };
  useDeepCompareEffect(() => {
    const mappedDeceseadVictims = defaultDeceasedVictims
      .map((el: any) => {
        return {
          victimId: el.id,
          victimKey: el.victimKey,
          judiciaryAmount: get(
            get(props.judgementOnMeritsRequest, 'jmv', []).find(
              (item: JudgementOnMeritsVictim) => item.victimId === el.id,
            ),
            'compensationAmount',
            el.judiciaryAmount,
          ),
          responsibilityShare: parseFloat(props.sharedResponsability),
          annualOfIncome: el.annualOfIncome,
          dateOfBirth: el.dateOfBirth,
          beneficiaries: get(el, 'beneficiaries', []),
        };
      })
      .filter((el: any) =>
        !isEmpty(props.associatedVictims)
          ? props.associatedVictims.includes(get(el, 'victimId'))
          : true,
      );
    props.handleChangeDesceasedVictim(
      !isEmpty(mappedDeceseadVictims)
        ? mappedDeceseadVictims
        : getDeceasedVictims(
            props.judgementAdd,
            props.judgementAddAppeal,
            props.currentJudiciaryProcess,
          )
            .map((el: any) => {
              return {
                victimId: el.id,
                judiciaryAmount: get(
                  get(props.judgementOnMeritsRequest, 'jmv', []).find(
                    (item: JudgementOnMeritsVictim) => item.victimId === el.id,
                  ),
                  'compensationAmount',
                  el.judiciaryAmount,
                ),
                responsibilityShare: parseFloat(props.sharedResponsability),
                annualOfIncome: el.annualOfIncome,
              };
            })
            .filter((el: any) =>
              !isEmpty(props.associatedVictims) &&
              !get(props.judgementOnMerits, 'judgementOnMerits.isFirst', false)
                ? props.associatedVictims.includes(get(el, 'victimId'))
                : true,
            ),
    );
    setDeceasedVictimsToShow(
      !isEmpty(defaultDeceasedVictims)
        ? defaultDeceasedVictims
        : getDeceasedVictims(
            props.judgementAdd,
            props.judgementAddAppeal,
            props.currentJudiciaryProcess,
          ),
    );
  }, [
    props.currentJudiciaryProcess,
    props.judgementAddAppeal,
    props.judgementAdd,
    props.associatedVictims,
    props.handleChangeDesceasedVictim,
    props.victims,
    props.dahirAmount,
  ]);
  const handleChangeExpanded = (
    event: React.ChangeEvent<{}>,
    expanded: boolean,
  ) => {
    event.stopPropagation();
    setExpanded(expanded);
  };

  const handleChangeJmv = (victim: any) => (
    e: ChangeEvent<{ value: string; name: string }>,
  ) => {
    const judgementOnMeritsRequest = { ...props.judgementOnMeritsRequest };
    const foundJmv =
      get(judgementOnMeritsRequest, 'jmv', []).find(
        (item: JudgementOnMeritsVictim) => item.victimId === victim?.id,
      ) || {};
    if (e.target.name === JUDGEMENT_ON_MERITS_VICTIM.FUNERAL_FEES) {
      !isEmpty(e.target.value)
        ? setShowFees({
            ...showFees,
            [victim?.id]: {
              ...showFees[victim?.id],
              [FEES.FUNERAL_BENEFICIARY_FEES]: true,
              [FEES.FUNERAL_VICTIM_FEES]: false,
            },
          })
        : setShowFees({
            ...showFees,
            [victim?.id]: {
              ...showFees[victim?.id],
              [FEES.FUNERAL_BENEFICIARY_FEES]: false,
              [FEES.FUNERAL_VICTIM_FEES]: false,
            },
          });
    }
    if (e.target.name === JUDGEMENT_ON_MERITS_VICTIM.MEDICAL_FEES) {
      !isEmpty(e.target.value)
        ? setShowFees({
            ...showFees,
            [victim?.id]: {
              ...showFees[victim?.id],
              [FEES.MEDICAL_BENEFICIARY_FEES]: true,
              [FEES.MEDICAL_VICTIM_FEES]: false,
            },
          })
        : setShowFees({
            ...showFees,
            [victim?.id]: {
              ...showFees[victim?.id],
              [FEES.MEDICAL_BENEFICIARY_FEES]: false,
              [FEES.MEDICAL_VICTIM_FEES]: false,
            },
          });
    }
    if (isEmpty(foundJmv)) {
      get(judgementOnMeritsRequest, 'jmv', []).push({
        victim,
        victimId: victim?.id,
        responsibilityShare: props.sharedResponsability,
        [e.target.name]: e.target.value,
        judgementOnMeritsId: get(
          props.judgementOnMerits,
          'judgementOnMerits.jom.id',
          undefined,
        ),
      });
    } else {
      const index = get(judgementOnMeritsRequest, 'jmv', []).indexOf(foundJmv);
      get(judgementOnMeritsRequest, 'jmv', [])[index] = {
        ...get(judgementOnMeritsRequest, 'jmv', [])[index],
        responsibilityShare: props.sharedResponsability,
        updated: true,
        [e.target.name]: e.target.value,
      };
    }
    props.setJudgementOnMeritsRequest(
      Object.assign(
        {},
        { ...judgementOnMeritsRequest },
        {
          jmv: [...get(judgementOnMeritsRequest, 'jmv', [])].flat(),
        },
      ),
    );
  };

  const handleChangeJudgementOnMerits = (victimIndex: number) => (
    judgement: IJudgementOnMeritsBeneficiaryInfo,
  ) => {
    const deceasedVictims = [...deceasedVictimsToShow];

    if (!isObjectAttributesEmpty(judgement)) {
      let victim = deceasedVictims[victimIndex];
      victim.beneficiaries.push({ ...judgement, victimId: victim.id });
    }
  };
  const desceasedVictims = resolveSlectedDeceasedVictims(
    deceasedVictimsToShow,
    [
      ...get(props, 'associatedVictims', []),
      ...get(props, 'jomDeceasedVictims', []),
    ],
    jomId,
    props.isMultiple,
  );
  const [showFees, setShowFees] = React.useState({}) as any;

  useEffect(() => {
    shouldShowFees(
      desceasedVictims,
      props.judgementOnMeritsRequest,
      setShowFees,
    );
  }, [deceasedVictimsToShow]);

  return checkVictimExistanceCivilParty(
    (props.desceasedVictims as unknown) as VictimType[],
    (props.allVictims as unknown) as VictimType[],
  ) &&
    checkVictimExistanceCivilParty(
      (props.desceasedVictims as unknown) as VictimType[],
      (props.allVictims as unknown) as VictimType[],
    ).includes(true) ? (
    <Grid className="deceased-victims">
      <Grid className="judgement-on-merits-title">
        {translate(messages.deceasedVictims, props)}
      </Grid>
      <Grid item xs={12} className="accordion-content">
        {desceasedVictims.map((victim: VictimType, indexVictim: number) => {
          const validateVictim = shouldValidateDesceasedVictim(
            victim,
            get(props.listing, 'civilJudgementVictimReason', []),
            get(props.judgementOnMeritsRequest, 'jmv', []),
            props,
          );
          const requiredErrors = get(
            validateVictim,
            'requiredErrors',
            {},
          ) as any;
          const alertErrors = get(validateVictim, 'alertErrors', {}) as any;
          return (
            <Container key={get(victim, 'id')}>
              <SahamAccordion
                expanded={expanded}
                onChange={handleChangeExpanded}
                title={translate({ ...messages.victimTitle }, props, {
                  name: ' ' + victim.firstName + ' ' + victim.lastName,
                })}
                accordionDetailsClassName="beneficiary-content"
              >
                <>
                  {areBeneficiariesDataInvalid(
                    get(victim, 'beneficiaries', []),
                    get(props.listing, 'civilJudgementVictimReason', []),
                  ) ? (
                    <span className="error">
                      {translate({ ...messages.beneficiariesAlert }, props)}
                    </span>
                  ) : (
                    <div className="validation-error">
                      {!victimConsistencyCheck(
                        props.judgementOnMerits,
                        victim,
                        get(props.judgementOnMeritsRequest, 'jmv', []),
                        desceasedVictims,
                      ) && (
                        <span className="error">
                          {translate(
                            { ...messages.victimConsistencyError },
                            props,
                          )}
                        </span>
                      )}
                      {(alertErrors[JUDGEMENT_ON_MERITS_VICTIM.MEDICAL_FEES] ||
                        alertErrors[JUDGEMENT_ON_MERITS_VICTIM.FUNERAL_FEES] ||
                        alertErrors[
                          JUDGEMENT_ON_MERITS_VICTIM.COMPENSATION_AMOUNT
                        ]) && (
                        <span className="error">
                          {alertErrors[
                            JUDGEMENT_ON_MERITS_VICTIM.MEDICAL_FEES
                          ] ||
                            alertErrors[
                              JUDGEMENT_ON_MERITS_VICTIM.FUNERAL_FEES
                            ] ||
                            alertErrors[
                              JUDGEMENT_ON_MERITS_VICTIM.COMPENSATION_AMOUNT
                            ]}
                        </span>
                      )}
                    </div>
                  )}
                  <div className="victim-info">
                    <div className="victim-info-item">
                      {translate({ ...messages.victimFullName }, props)}
                      <div className="victim-info-sub-item">
                        {victim.firstName + ' ' + victim.lastName}
                      </div>
                    </div>
                    <div className="victim-info-item">
                      {translate({ ...messages.referenceCapital }, props)}
                      <div className="victim-info-sub-item">
                        {victim.referenceCapital}
                      </div>
                    </div>

                    <div className="victim-info-item">
                      {translate({ ...messages.calculatedEvaluation }, props)}
                      <div className="victim-info-sub-item">
                        {resolveCalculatedAmount(
                          victim,
                          props.dahirAmount,
                          props.judgementOnMeritsRequest,
                        )}
                      </div>
                    </div>
                    <TextField
                      name={JUDGEMENT_ON_MERITS_VICTIM.COMPENSATION_AMOUNT}
                      type="number"
                      error={
                        requiredErrors[
                          JUDGEMENT_ON_MERITS_VICTIM.COMPENSATION_AMOUNT
                        ]
                      }
                      helperText={
                        requiredErrors[
                          JUDGEMENT_ON_MERITS_VICTIM.COMPENSATION_AMOUNT
                        ]
                      }
                      label={translate(messages.judiciaryEvaluation, props)}
                      value={resolveJudiciaryAmount(
                        props.judgementOnMerits,
                        props.desceasedVictims,
                        get(victim, 'id', ''),
                        get(props.judgementOnMeritsRequest, 'jmv', []),
                      )}
                      className="deceased-victim"
                      onChange={handleChangeJmv(victim)}
                      InputProps={{
                        readOnly: !props.isManager
                          ? get(
                              props.judgementOnMerits,
                              'judgementOnMerits.status',
                            ) !== STATUS_REJECTED &&
                            !isEmpty(props.judgementOnMerits)
                          : false,
                      }}
                    />
                    {featureService.hasFeature(
                      FEATURES.JUDGEMENT_ON_MERITS_INFO,
                    ) &&
                      !get(
                        showFees[(victim?.id as unknown) as number],
                        FEES.MEDICAL_VICTIM_FEES,
                        false,
                      ) && (
                        <TextField
                          name={JUDGEMENT_ON_MERITS_VICTIM.MEDICAL_FEES}
                          type="number"
                          label={translate(messages.medicalFees, props)}
                          value={get(
                            getJudgementOnMeritsByVictim(
                              get(props.judgementOnMeritsRequest, 'jmv', []),
                              (get(victim, 'id') as unknown) as number,
                            ),
                            JUDGEMENT_ON_MERITS_VICTIM.MEDICAL_FEES,
                          )}
                          className="deceased-victim"
                          onChange={handleChangeJmv(victim)}
                          InputProps={{
                            readOnly: !props.isManager
                              ? get(
                                  props.judgementOnMerits,
                                  'judgementOnMerits.status',
                                ) !== STATUS_REJECTED &&
                                !isEmpty(props.judgementOnMerits)
                              : false,
                          }}
                          error={
                            requiredErrors[
                              JUDGEMENT_ON_MERITS_VICTIM.MEDICAL_FEES
                            ]
                          }
                          helperText={
                            requiredErrors[
                              JUDGEMENT_ON_MERITS_VICTIM.MEDICAL_FEES
                            ]
                          }
                        />
                      )}
                    {!get(
                      showFees[(victim?.id as unknown) as number],
                      FEES.FUNERAL_VICTIM_FEES,
                      false,
                    ) &&
                      featureService.hasFeature(
                        FEATURES.JUDGEMENT_ON_MERITS_INFO,
                      ) && (
                        <TextField
                          name={JUDGEMENT_ON_MERITS_VICTIM.FUNERAL_FEES}
                          type="number"
                          label={translate(messages.funeralFees, props)}
                          value={get(
                            getJudgementOnMeritsByVictim(
                              get(props.judgementOnMeritsRequest, 'jmv', []),
                              (get(victim, 'id') as unknown) as number,
                            ),
                            JUDGEMENT_ON_MERITS_VICTIM.FUNERAL_FEES,
                          )}
                          className="deceased-victim"
                          onChange={handleChangeJmv(victim)}
                          InputProps={{
                            readOnly: !props.isManager
                              ? get(
                                  props.judgementOnMerits,
                                  'judgementOnMerits.status',
                                ) !== STATUS_REJECTED &&
                                !isEmpty(props.judgementOnMerits)
                              : false,
                          }}
                          error={
                            requiredErrors[
                              JUDGEMENT_ON_MERITS_VICTIM.FUNERAL_FEES
                            ]
                          }
                          helperText={
                            requiredErrors[
                              JUDGEMENT_ON_MERITS_VICTIM.FUNERAL_FEES
                            ]
                          }
                        />
                      )}
                  </div>
                  <Grid container spacing={1}>
                    {victim.beneficiaries.map(
                      (beneficiary: any, index: number) => (
                        <BeneficiaryInfo
                          key={index}
                          beneficiary={beneficiary}
                          index={index}
                          deceasedVictimsToShow={deceasedVictimsToShow}
                          setDeceasedVictimsToShow={setDeceasedVictimsToShow}
                          setShowFees={setShowFees}
                          showFees={showFees}
                          associatedVictims={props.associatedVictims}
                          lossDate={props.lossDate}
                          handleChangeBeneficiaries={
                            props.handleChangeBeneficiaries
                          }
                          listings={props.listing}
                          isRecap={props.isRecap}
                          RecapInfo={props.RecapInfo}
                          beneficiaryContestationReasons={
                            props.beneficiaryContestationReasons
                          }
                          setBeneficiaryContestationReasons={
                            props.setBeneficiaryContestationReasons
                          }
                          victim={victim}
                          isManager={props.isManager}
                          judgementOnMerits={props.judgementOnMerits}
                          judgement={judgement}
                          setJudgement={setJudgement}
                          handleItemCheckBox={handleItemCheckBox}
                          isDisabled={
                            !props.isManager &&
                            !isRejected(props.judgementOnMerits) &&
                            !isEmpty(
                              get(props.judgementOnMerits, 'judgementOnMerits'),
                            )
                          }
                        />
                      ),
                    )}
                    {showAddBeneficiaries(
                      props.isManager,
                      props.isRecap,
                      props.judgementOnMerits,
                    ) && (
                      <PrimaryButton
                        data-testid="add_beneficiary_btn"
                        className="add-beneficiary-btn"
                        onClick={() => openFormBeneficiary(indexVictim)}
                        title={translate(
                          { ...messages.addBeneficiaryBtn },
                          props,
                        )}
                      />
                    )}
                    {openBeneficiaryForm[indexVictim] && (
                      <Grid item xs={12}>
                        <BeneficiaryAccordion
                          listing={props.listing}
                          disableInput={false}
                          handleCancel={() => closeFormBeneficiary(indexVictim)}
                          beneficiary={
                            {
                              [BENEFICIARY.DEPENDENT_INDICATOR]: true,
                            } as any
                          }
                          victimKey={victim.victimKey}
                          victimId={(victim.id as unknown) as number}
                          setBeneficiariesJudgementOnMerits={handleChangeJudgementOnMerits(
                            indexVictim,
                          )}
                          victim={victim}
                          handleItemCheckBox={handleItemCheckBox}
                          newBeneficiaries={props.beneficiairies}
                          handleChangeNewBeneficiaries={
                            props.handleChangeBeneficiaries
                          }
                          index={get(victim, 'beneficiaries', []).length}
                          deceasedVictimsToShow={deceasedVictimsToShow}
                          setDeceasedVictimsToShow={setDeceasedVictimsToShow}
                          setShowFees={setShowFees}
                          showFees={showFees}
                          lossDate={props.lossDate}
                          judgement={judgement}
                          setJudgement={setJudgement}
                          judgementOnMerits={props.judgementOnMerits}
                          isManager={props.isManager}
                        />
                      </Grid>
                    )}
                  </Grid>
                </>
              </SahamAccordion>
            </Container>
          );
        })}
      </Grid>
    </Grid>
  ) : (
    <></>
  );
};

export default injectIntl(DeceasedVictim);
